import { Card, Box, Typography } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { Trip, Workday } from '../models/workday';
import { formatTime } from '../utils/dateTime';
import { DatePicker } from './DatePicker';
import { InfoCard, InfoCardContent } from './InfoCard/InfoCard';
import { ServiceCard, ServiceCardContent } from './ServiceCard/ServiceCard';
import { IconType } from '../enums/IconType';
import { SxProps } from '@mui/system';

type Props = {
  workdays: Workday[];
  currentWorkday: Workday;
  handleDateChange: Function;
};

const classes: SxProps = {
  timeUpdate: {
    fontStyle: 'italic',
    textAlign: 'center',
    color: 'grey',
  },
  euLogo: {
    width: '30px',
    marginTop: '5px',
  },
};

export const Header: FC<Props> = ({
  workdays,
  currentWorkday,
  handleDateChange,
}) => {
  const [isEuTrip, setIsEu] = useState(false);
  useEffect(() => {
    const hasEuTrips = currentWorkday?.DutyActivity?.some((da) =>
      da.Trip.some((trip: Trip) => trip.TripIsEu),
    );
    setIsEu(hasEuTrips);
  }, [currentWorkday]);

  return (
    <Card>
      <Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Box px={4} py={2}>
            <Typography id="username" variant="h5">
              {currentWorkday?.EmpFirstName}
            </Typography>
            <Box>
              <DatePicker
                workdays={workdays}
                handleDateChange={handleDateChange}
              />
            </Box>
            {currentWorkday !== undefined &&
              (currentWorkday.ScheduledToWork === undefined ||
                currentWorkday?.ScheduledToWork) && (
                <>
                  <Typography id="start-time" variant="subtitle2">
                    Start {formatTime(currentWorkday?.WdyTimeStart!)}
                  </Typography>
                  <Typography id="end-time" variant="subtitle2">
                    Slut {formatTime(currentWorkday?.WdyTimeEnd!)}
                  </Typography>
                </>
              )}
          </Box>
          {isEuTrip && (
            <Box px={4}>
              <img
                style={{ width: '60px', marginTop: '5px' }}
                src="/assets/eu-flag.jpg"
                alt="EU"
              />
            </Box>
          )}
        </Box>
        {currentWorkday !== undefined &&
          currentWorkday?.WdyDate.toString().split('T')[0] !==
            new Date(Date.now()).toISOString().split('T')[0] && (
            <Box px={1} py={1}>
              <InfoCard>
                <InfoCardContent
                  comment={'Du ser ej dagens arbete nu.'}
                  icon={IconType.Warning}
                />
              </InfoCard>
            </Box>
          )}
        {currentWorkday?.WdyCommentForSelfservice! && (
          <Box px={1} py={1}>
            <InfoCard>
              <InfoCardContent
                comment={currentWorkday?.WdyCommentForSelfservice}
                icon={IconType.Info}
              />
            </InfoCard>
          </Box>
        )}
        {(currentWorkday?.ScheduledToWork === undefined ||
          !currentWorkday?.ScheduledToWork) && (
          <Box px={1} py={1}>
            <Typography align="center" variant="subtitle1">
              Inget arbete kunde hittas för idag. Kontakta trafikledningen om du
              förväntade annat.
            </Typography>
          </Box>
        )}
        {currentWorkday?.WorkdayServiceMessage && (
          <ServiceCard>
            <ServiceCardContent
              serviceMessage={currentWorkday?.WorkdayServiceMessage}
            />
          </ServiceCard>
        )}
      </Box>

      {currentWorkday !== undefined && (
        <Box sx={classes.timeUpdate}>
          <Typography id="updated" variant="caption">
            Uppdaterad: {currentWorkday.UpdatedTime.toString().split('T')[0]}{' '}
            {currentWorkday.UpdatedTime.toString()
              .split('T')[1]
              ?.substring(0, 5)}
          </Typography>
        </Box>
      )}
    </Card>
  );
};
